import React, {  } from 'react';
import MainMenuComponent from '../../Components/Menus/MainMenuComponent';

const ApprovalHome = () => {

  return (
    <MainMenuComponent menuName="approval" />
  );
};

export default ApprovalHome;
